import links from "@/links/links";
import qs from "qs";

export default {
  actions: {
    QUERY_FETCH_PROPERTIES(agencyId, properties) {
      let propertiesString = "";
      properties.forEach(prop => {
        if (typeof prop == "string") {
          propertiesString += `&properties[]=${prop}`;
        } else if (typeof prop == "object") {
          for (const [key, values] of Object.entries(prop)) {
            for (const value of values) {
              propertiesString += `&properties[${key}][]=${value}`;
            }
          }
        }
      });
      return this.get(links.BUILDING_QUERY_FETCH_PROPERTIES(agencyId, propertiesString), {
        dataKey: "hydra:member",
      });
    },
    FETCH(agencyId) {
      return this.get(links.BUILDING_FETCH(agencyId), {
        dataTransformer: res => {
          // HACK: don't save meetings in store
          var buildings = res.data["hydra:member"];
          buildings.forEach(building => {
            delete building.meetings;
          });
          return buildings;
        },
      });
    },
    // NOTE: get with related building_owners, building_lots
    QUERY_FETCH(agencyId, queryParams) {
      // NOTE: prepare query params
      var processedQueryParams = {};
      // filters
      queryParams.filter.forEach(filter => {
        processedQueryParams[filter.column] = filter.value;
      });
      // order
      processedQueryParams[`order[${queryParams.sort.by}]`] = queryParams.sort.dir.toLowerCase();
      // page
      processedQueryParams.page = queryParams.page;
      processedQueryParams.itemsPerPage = queryParams.itemsPerPage;
      return this.get(links.BUILDING_QUERY_FETCH(), {
        params: processedQueryParams,
        paramsSerializer: params => {
          return qs.stringify(params);
        },
        dataKey: "hydra:member",
      });
    },
    QUERY_FETCH_WITH_PROPERTIES_AND_PAGINATION(agencyId, queryParams, properties) {
      // NOTE: prepare query params
      var processedQueryParams = {};
      // filters
      queryParams.filter.forEach(filter => {
        processedQueryParams[filter.column] = filter.value;
      });
      // order
      processedQueryParams[`order[${queryParams.sort.by}]`] = queryParams.sort.dir.toLowerCase();
      // page
      processedQueryParams.page = queryParams.page;
      processedQueryParams.itemsPerPage = queryParams.itemsPerPage;

      let propertiesString = "";
      properties.forEach(prop => {
        if (typeof prop == "string") {
          propertiesString += `&properties[]=${prop}`;
        } else if (typeof prop == "object") {
          for (const [key, values] of Object.entries(prop)) {
            for (const value of values) {
              propertiesString += `&properties[${key}][]=${value}`;
            }
          }
        }
      });

      return this.get(links.BUILDING_QUERY_FETCH() + `?agency_id=${agencyId}${propertiesString}`, {
        params: processedQueryParams,
        paramsSerializer: params => {
          return qs.stringify(params);
        },
        dataKey: "hydra:member",
      });
    },
    // NOTE: get with related building_owners, building_lots
    GET(id) {
      return this.get(links.BUILDING_GET(id));
    },
    POST(item) {
      return this.post(links.BUILDING_POST(), item);
    },
    PUT(item) {
      return this.put(links.BUILDING_PUT(item.id), item);
    },
    DELETE(item) {
      return this.delete(links.BUILDING_DELETE(item.id), {
        delete: item.id,
      });
    },
    // FIXME: GET??
    CUSTOM_DELETE(id) {
      return this.get(links.BUILDING_CUSTOM_DELETE(id));
    },
    REGISTER_GET_BUILDING(meetingId) {
      let params = {};
      if (meetingId) {
        params["meeting_id"] = meetingId;
      }
      return this.get(links.BUILDING_MEETING_REGISTER() + "?" + qs.stringify(params));
    },
    BUILDINGS_LIST() {
      return this.get(links.BUILDINGS_LIST());
    },
  },
};
